<div class="flex justify-content-center p-0">
	<div class="p-col-12 p-md-6 p-lg-33 px-3 py-0">
		<div class="flex justify-content-center p-0">
			<div class="p-col-12 p-md-6 p-lg-3 p-0">
				<h3 class="first">{{ 'h3.screenReceivingTitle' | translate }}</h3>
			</div>
		</div>

		<div class="pb-0">
			<label>{{ 'label.placeholderLabel' | translate }}</label>
			<input type="text" maxlength="16" pInputText
				[ngClass]="{focusField: inputFields[0].focus}" tabindex="-1"
				id="{{ inputFields[0].id }}" [(ngModel)]="inputFields[0].value"
				(keydown.enter)="checkLabel()"
				(focus)="focusInputFields('label_code')"
				(blur)="blurInputFields('label_code')"
				(ngModelChange)="resetLabel()">
		</div>

		<div *ngIf="receivingManagementGroupResponse" class="p-col-12 label-response-container">
			<h5>{{ 'h5.numberOfVolumes' | translate }} : {{receivingManagementGroupResponse.boxVol}}</h5>
			<h5>{{ 'h5.invoicesQuantity' | translate }} : {{receivingManagementGroupResponse.docQuantity}}</h5>
		</div>

		<div class="pb-0">
			<label>{{ 'label.placeholderStaging' | translate }}</label>
			<input type="text" maxlength="16" pInputText
				[ngClass]="{focusField: inputFields[1].focus}" tabindex="-1"
				id="{{ inputFields[1].id }}" [disabled]="disabledStaging"
				[(ngModel)]="inputFields[1].value"
				(keydown.enter)="checkStaging()"
				(focus)="focusInputFields('staging_code')"
				(blur)="blurInputFields('staging_code')"
				(ngModelChange)="setInputToInvalid('staging_code')"
				>
		</div>

		<div class="flex justify-content-center p-0">
			<div class="p-col-12 p-md-6 p-lg-3 p-0">
				<button class="submit" type="submit" pButton (click)="clickSave()" label="{{ 'button.save' | translate }}" [disabled]="checkAbleSave()"></button>
				<button class="submit" type="submit" pButton (click)="clickPrint()" label="{{ 'button.print' | translate }}" [disabled]="disabledClickPrint"></button>
			</div>
		</div>
	</div>
</div>

<input-generic
	[inputFields]="inputFields"
	(eventEmitter)="executeAction($event)">
</input-generic>

<alert-custom *ngIf="showAlert"
		(onCloseModal)="hideErrorModal($event)"
		[msg]="errorMessage"
		[elId]="errorFocus"
		[title]="errorTitle">
</alert-custom>
